import React from 'react';
import { callApi } from '../../../Utils/Api/Api';
import GoogleLogo from '../../../assets/logo/google@72x.png';
import { Button } from '@progress/kendo-react-buttons';

const GoogleLoginButton = ({ setIsLoader, setAlertMessage }) => {
  const handleSocialLogin = async (driver) => {
    setIsLoader(true);
    try {
      const response = await callApi(`/social/auth/URL?driver=${driver}`, 'GET');
      if (response?.isSuccess) {
        window.location.href = response.payload.scalar;
      } else {
        setAlertMessage({ alert: true, message: 'Failed to get social login URL. Please try again.' });
      }
    } catch (error) {
      console.error('Get social login URL error:', error);
      setAlertMessage({ alert: true, message: 'Failed to get social login URL. Please try again.' });
    } finally {
      setIsLoader(false);
    }
  };

  return (
    <div className='social-login-box '>
      <Button
        imageUrl={GoogleLogo}
        fillMode='outline'
        className='google-login-btn'
        onClick={() => handleSocialLogin('google')}
      >
        SIGN IN WITH GOOGLE
      </Button>
    </div>
  );
};

export default GoogleLoginButton;
